export function formatCount(count: number, singular: string, plural?: string) {
  const pluralForm = plural ?? `${singular}s`;
  return `${count} ${count === 1 ? singular : pluralForm}`;
}
